import * as actionsTypes from './actionsTypes';

const initialState = {
  surveyResults: [],
  isLoading: false,
  error: "",
  surveyType: "Encuesta",
  surveyInfo: null,
  isSurveyInfoLoading: false,
}

export default function surveyResultsReducer(state = initialState, action){
  switch (action.type) {
    case actionsTypes.FETCH_SURVEY_RESULTS_REQUEST:
      return {...state, isLoading: action.payload}
    
    case actionsTypes.FETCH_SURVEY_INFO_REQUEST:
      return {...state, isSurveyInfoLoading: action.payload}
    
    case actionsTypes.FETCH_SURVEY_INFO_SUCCESS:
      const surveyData = action.payload;
      
      return {
        ...state,
        surveyType: surveyData.survey_type || 'Encuesta',
        surveyInfo: {
          surveyName: surveyData.survey_name || surveyData.name,
          surveyId: surveyData.id,
          surveyType: surveyData.survey_type
        },
        isSurveyInfoLoading: false,
        error: ""
      };
    
    case actionsTypes.FETCH_SURVEY_INFO_FAILURE:
      return {
        ...state,
        isSurveyInfoLoading: false,
        error: action.payload
      };
    
    case actionsTypes.FETCH_SURVEY_RESULTS_SUCCESS:
      const results = Array.isArray(action.payload) ? action.payload : [];
      
      return {
        ...state, 
        surveyResults: results,
        error: "",
        isLoading: false
      };
    
    case actionsTypes.FETCH_SURVEY_RESULTS_FAILURE:
      return { 
        ...state, 
        error: action.payload, 
        surveyResults: [], 
        isLoading: false 
      };
    
    default:
      return state;
  }
}